import { render, staticRenderFns } from "./CallEnded.vue?vue&type=template&id=4353f795&"
import script from "./CallEnded.vue?vue&type=script&lang=js&"
export * from "./CallEnded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports